<div class="dialog-header">
    <div class="title">Third Party Notice</div>
    <div class="items">
        <span (click)="cancelSelected()" class="material-icons md-dark close padding all">close</span>
    </div>
</div>

<div class="wrapper">
    <div class="padding lrg all">
        <div class="row">
            <div class="col">
                {{ formattedLicenFile }}
            </div>
        </div>
    </div>
</div>
